export const enum ReportType {
  Sales,
  Transaction,
  ProductInventory,
}
